import { useCallback, useState } from 'react';
import { useCheckoutApi } from '../Api';
import { CalendlyEventDetails } from '../types/checkout';

interface EventDetailsState {
  data: CalendlyEventDetails | null;
  loading: boolean;
  error: boolean;
}

export function useCalendlyEventDetails() {
  const checkoutApi = useCheckoutApi();
  const [state, setState] = useState<EventDetailsState>({
    data: null,
    loading: false,
    error: false,
  });

  const fetchEventDetails = useCallback(
    async (checkoutOrderId: number) => {
      setState({ data: null, loading: true, error: false });
      try {
        const response = await checkoutApi.get<CalendlyEventDetails>(
          '/api/booking/event-details',
          { params: { checkoutOrderId } }
        );
        setState({ data: response.data, loading: false, error: false });
      } catch {
        setState({ data: null, loading: false, error: true });
      }
    },
    [checkoutApi]
  );

  const clear = useCallback(() => {
    setState({ data: null, loading: false, error: false });
  }, []);

  return { ...state, fetchEventDetails, clear };
}
